import { firebase } from 'utils'

export const sendGroupEmail = firebase
  .functions()
  .httpsCallable('sendGroupEmail')
